(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands-directory"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function normalize(value) {
      var normalized = String(value || '').toLocaleLowerCase();

      if (typeof normalized.normalize === 'function') {
        normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
      }

      return normalized.trim();
    }

    function initializeBrandsDirectory(root) {
      if (!root || root.getAttribute('data-brands-initialized') === 'true') return;

      var input = root.querySelector('[data-brands-search]');
      if (!input) return;

      root.setAttribute('data-brands-initialized', 'true');

      var clearButton = root.querySelector('[data-brands-clear]');
      var status = root.querySelector('[data-brands-status]');
      var emptyState = root.querySelector('[data-brands-empty]');
      var popularSection = root.querySelector('[data-popular]');
      var alphabet = root.querySelector('[data-brands-alphabet]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-brand-card]'));
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-letter-group]'));
      var letterLinks = Array.prototype.slice.call(root.querySelectorAll('[data-letter-link]'));

      function update() {
        var query = normalize(input.value);
        var visibleCount = 0;

        cards.forEach(function (card) {
          var isVisible = query === '' || normalize(card.getAttribute('data-brand-name')).indexOf(query) !== -1;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        groups.forEach(function (group) {
          var groupCards = Array.prototype.slice.call(group.querySelectorAll('[data-brand-card]'));
          var hasVisibleBrand = groupCards.some(function (card) {
            return !card.hidden;
          });
          group.hidden = !hasVisibleBrand;
        });

        letterLinks.forEach(function (link) {
          var relatedGroup = null;
          var linkLetter = link.getAttribute('data-brand-letter');

          groups.forEach(function (group) {
            if (!relatedGroup && group.getAttribute('data-brand-letter') === linkLetter) relatedGroup = group;
          });

          link.hidden = Boolean(relatedGroup && relatedGroup.hidden);
        });

        if (popularSection) popularSection.hidden = query !== '';
        if (alphabet) alphabet.hidden = visibleCount === 0;
        if (clearButton) clearButton.hidden = query === '';
        if (emptyState) emptyState.hidden = visibleCount !== 0;

        if (status) {
          status.textContent = query === '' ? '' : root.getAttribute('data-results-text').replace('[count]', String(visibleCount));
        }
      }

      function clear() {
        input.value = '';
        update();
        input.focus();
      }

      input.addEventListener('input', update);
      input.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || input.value === '') return;
        event.preventDefault();
        clear();
      });

      if (clearButton) clearButton.addEventListener('click', clear);
    }

    function initializeAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-brands-directory]');
      Array.prototype.forEach.call(roots, initializeBrandsDirectory);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
